<script>
	import { state } from "../store";
	import { action } from "../api";

	$: game = $state.game;
	$: question = game.question;
	$: me = $state.players.find((player) => {
		return player.isYou;
	});

	let solution = "";
	let insensitive = true;
	let solved = false;

	$: flags = insensitive ? "i" : "";

	$: matches = [];
	$: nonMatches = [];

	let solutionUpdateScheduled = false;

	$: if (game.question && game.question.type === "write") {
		matches = game.question.matches.map((match) => {
			return {
				text: match,
				matched: false,
			};
		});
		nonMatches = game.question.nonMatches.map((nonMatch) => {
			return {
				text: nonMatch,
				matched: false,
			};
		});
		checkSolution();
	}

	const updateSolution = () => {
		if (!solutionUpdateScheduled && me && (solution !== me.solution || flags !== me.flags )) {
			solutionUpdateScheduled = true;
			setTimeout(() => {
				solutionUpdateScheduled = false;
				action("solution", solution, flags, solved);
			}, 500);
		}
	}

	const checkSolution = () => {
		let regex = null;
		try {
			regex = new RegExp(solution, flags);
		}
		catch {}

		if (!solution || !regex) {
			matches = matches.map(({ text }) => {
				return {
					text,
					matched: false,
				};
			});
			nonMatches = nonMatches.map(({ text }) => {
				return {
					text,
					matched: false,
				};
			});
		}
		else {
			matches = matches.map(({ text }) => {
				regex.lastIndex = 0;
				return {
					text,
					matched: regex.test(text),
				};
			});
			nonMatches = nonMatches.map(({ text }) => {
				regex.lastIndex = 0;
				return {
					text,
					matched: regex.test(text),
				};
			});
		}

		if (matches.reduce((solved, { matched }) => {
			return solved && matched;
		}, true) && nonMatches.reduce((solved, { matched }) => {
			return solved && !matched;
		}, true)) {
			solved = true;
		}
		else {
			solved = false;
		}

		updateSolution();
	}
</script>


<div class="question">{question.text}</div>
<div class="input">
	<div>
		<input type="text" bind:value={solution} on:input={checkSolution} />
	</div>
	<div>
		<input type="checkbox" name="insensitiveCheckbox" bind:checked={insensitive} on:change={checkSolution}>
		<label for="insensitiveCheckbox">insensitive</label>
	</div>
</div>
<div class="answers">
	<div class="matches">
		<div class="answerTitle">
			Matches
		</div>
		{#each matches as { text, matched }}
			<div class={"answer " + (matched ? "matched" : "nonMatched")}>{text}</div>
		{/each}
	</div>
	<div class="matches">
		<div class="answerTitle">
			Non-Matches
		</div>
		{#each nonMatches as { text, matched }}
			<div class={"answer " + (matched ? "matched" : "nonMatched")}>{text}</div>
		{/each}
	</div>
</div>

<style>
	.question {
		font-size: 1.5em;
		font-weight: bold;
		margin-bottom: 40px;
	}

	.input {
		display: flex;
		justify-content: center;

		margin-bottom: 40px;
	}

	input[type=text] {
		background-color: #fafaff;
		width: 340px;

		font-family: var(--font-family-mono);
		font-size: 1.2em;

		margin-left: 5px;
		margin-right: 5px;
	}

	.answers {
		display: flex;
		flex-direction: row;
		justify-content: center;
		text-align: left;

		font-size: 1.2em;
	}

	.answerTitle {
		font-weight: bold;
		margin-bottom: 20px;
	}

	.matches {
		margin-right: 80px;
		margin-left: 80px;
	}

	.answer {
		font-family: var(--font-family-mono);
		margin-bottom: 4px;
	}

	.matched {
		color: var(--green);
	}

	.nonMatched {
		color: var(--red);
	}
</style>